/**
 * DLP APi
 * DLP Services
 *
 * OpenAPI spec version: 1.0
 * Contact: check
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { CstAutofillDto } from '../model/cstAutofillDto';
import { CstIndiIncomeDto } from '../model/cstIndiIncomeDto';
import { CstInfoRemoveDto } from '../model/cstInfoRemoveDto';
import { CustQuotOtpEntityIdDto } from '../model/custQuotOtpEntityIdDto';
import { CustomerInfoDto } from '../model/customerInfoDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class PersonalInfoControllerService {

    protected basePath = 'https://localhost:8080/nrfsi/nissan';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * getCstIncomeDetails
     * 
     * @param cstId CstId
     * @param portfolioId PortfolioId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCstIncomeDetailsUsingGET(cstId: string, portfolioId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<CstIndiIncomeDto>>;
    public getCstIncomeDetailsUsingGET(cstId: string, portfolioId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CstIndiIncomeDto>>>;
    public getCstIncomeDetailsUsingGET(cstId: string, portfolioId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CstIndiIncomeDto>>>;
    public getCstIncomeDetailsUsingGET(cstId: string, portfolioId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cstId === null || cstId === undefined) {
            throw new Error('Required parameter cstId was null or undefined when calling getCstIncomeDetailsUsingGET.');
        }

        if (portfolioId === null || portfolioId === undefined) {
            throw new Error('Required parameter portfolioId was null or undefined when calling getCstIncomeDetailsUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<CstIndiIncomeDto>>(`${this.basePath}/applicant/income/${encodeURIComponent(String(portfolioId))}/${encodeURIComponent(String(cstId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getCustomer
     * 
     * @param custId custId
     * @param portfolioId portfolioId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCustomerUsingGET(custId: string, portfolioId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<CustomerInfoDto>>;
    public getCustomerUsingGET(custId: string, portfolioId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CustomerInfoDto>>>;
    public getCustomerUsingGET(custId: string, portfolioId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CustomerInfoDto>>>;
    public getCustomerUsingGET(custId: string, portfolioId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (custId === null || custId === undefined) {
            throw new Error('Required parameter custId was null or undefined when calling getCustomerUsingGET.');
        }

        if (portfolioId === null || portfolioId === undefined) {
            throw new Error('Required parameter portfolioId was null or undefined when calling getCustomerUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<CustomerInfoDto>>(`${this.basePath}/applicant/info/${encodeURIComponent(String(portfolioId))}/${encodeURIComponent(String(custId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getDefaultInfo
     * 
     * @param portfolioId portfolioId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDefaultInfoUsingGET1(portfolioId: number, observe?: 'body', reportProgress?: boolean): Observable<CstAutofillDto>;
    public getDefaultInfoUsingGET1(portfolioId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CstAutofillDto>>;
    public getDefaultInfoUsingGET1(portfolioId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CstAutofillDto>>;
    public getDefaultInfoUsingGET1(portfolioId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (portfolioId === null || portfolioId === undefined) {
            throw new Error('Required parameter portfolioId was null or undefined when calling getDefaultInfoUsingGET1.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<CstAutofillDto>(`${this.basePath}/applicant/autofill/${encodeURIComponent(String(portfolioId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * removeCoBorrowerIncome
     * 
     * @param cstInfoRemoveDtos cstInfoRemoveDtos
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeCoBorrowerIncomeUsingDELETE(cstInfoRemoveDtos: Array<CstInfoRemoveDto>, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public removeCoBorrowerIncomeUsingDELETE(cstInfoRemoveDtos: Array<CstInfoRemoveDto>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public removeCoBorrowerIncomeUsingDELETE(cstInfoRemoveDtos: Array<CstInfoRemoveDto>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public removeCoBorrowerIncomeUsingDELETE(cstInfoRemoveDtos: Array<CstInfoRemoveDto>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cstInfoRemoveDtos === null || cstInfoRemoveDtos === undefined) {
            throw new Error('Required parameter cstInfoRemoveDtos was null or undefined when calling removeCoBorrowerIncomeUsingDELETE.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.delete<string>(`${this.basePath}/applicant/income`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * removeCoBorrower
     * 
     * @param cstInfoRemoveDtos cstInfoRemoveDtos
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeCoBorrowerUsingDELETE(cstInfoRemoveDtos: Array<CstInfoRemoveDto>, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public removeCoBorrowerUsingDELETE(cstInfoRemoveDtos: Array<CstInfoRemoveDto>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public removeCoBorrowerUsingDELETE(cstInfoRemoveDtos: Array<CstInfoRemoveDto>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public removeCoBorrowerUsingDELETE(cstInfoRemoveDtos: Array<CstInfoRemoveDto>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cstInfoRemoveDtos === null || cstInfoRemoveDtos === undefined) {
            throw new Error('Required parameter cstInfoRemoveDtos was null or undefined when calling removeCoBorrowerUsingDELETE.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.delete<string>(`${this.basePath}/applicant/info`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * resetQuotationDetails
     * 
     * @param custQuotOtpEntityIdDto custQuotOtpEntityIdDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resetQuotationDetailsUsingDELETE(custQuotOtpEntityIdDto: CustQuotOtpEntityIdDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public resetQuotationDetailsUsingDELETE(custQuotOtpEntityIdDto: CustQuotOtpEntityIdDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public resetQuotationDetailsUsingDELETE(custQuotOtpEntityIdDto: CustQuotOtpEntityIdDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public resetQuotationDetailsUsingDELETE(custQuotOtpEntityIdDto: CustQuotOtpEntityIdDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (custQuotOtpEntityIdDto === null || custQuotOtpEntityIdDto === undefined) {
            throw new Error('Required parameter custQuotOtpEntityIdDto was null or undefined when calling resetQuotationDetailsUsingDELETE.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.delete<string>(`${this.basePath}/applicant/quotation`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * saveCstIncomeDetails
     * 
     * @param cstIndiIncome cstIndiIncome
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public saveCstIncomeDetailsUsingPOST1(cstIndiIncome: Array<CstIndiIncomeDto>, observe?: 'body', reportProgress?: boolean): Observable<Array<CstIndiIncomeDto>>;
    public saveCstIncomeDetailsUsingPOST1(cstIndiIncome: Array<CstIndiIncomeDto>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CstIndiIncomeDto>>>;
    public saveCstIncomeDetailsUsingPOST1(cstIndiIncome: Array<CstIndiIncomeDto>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CstIndiIncomeDto>>>;
    public saveCstIncomeDetailsUsingPOST1(cstIndiIncome: Array<CstIndiIncomeDto>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (cstIndiIncome === null || cstIndiIncome === undefined) {
            throw new Error('Required parameter cstIndiIncome was null or undefined when calling saveCstIncomeDetailsUsingPOST1.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<CstIndiIncomeDto>>(`${this.basePath}/applicant/income`,
            cstIndiIncome,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * savePersonalInfo
     * 
     * @param listPersonlInfo listPersonlInfo
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public savePersonalInfoUsingPOST1(listPersonlInfo: Array<CustomerInfoDto>, observe?: 'body', reportProgress?: boolean): Observable<Array<CustomerInfoDto>>;
    public savePersonalInfoUsingPOST1(listPersonlInfo: Array<CustomerInfoDto>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CustomerInfoDto>>>;
    public savePersonalInfoUsingPOST1(listPersonlInfo: Array<CustomerInfoDto>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CustomerInfoDto>>>;
    public savePersonalInfoUsingPOST1(listPersonlInfo: Array<CustomerInfoDto>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (listPersonlInfo === null || listPersonlInfo === undefined) {
            throw new Error('Required parameter listPersonlInfo was null or undefined when calling savePersonalInfoUsingPOST1.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<CustomerInfoDto>>(`${this.basePath}/applicant/info`,
            listPersonlInfo,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updatePersonalInfo
     * 
     * @param listPersonlInfo listPersonlInfo
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatePersonalInfoUsingPUT(listPersonlInfo: Array<CustomerInfoDto>, observe?: 'body', reportProgress?: boolean): Observable<Array<CustomerInfoDto>>;
    public updatePersonalInfoUsingPUT(listPersonlInfo: Array<CustomerInfoDto>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CustomerInfoDto>>>;
    public updatePersonalInfoUsingPUT(listPersonlInfo: Array<CustomerInfoDto>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CustomerInfoDto>>>;
    public updatePersonalInfoUsingPUT(listPersonlInfo: Array<CustomerInfoDto>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (listPersonlInfo === null || listPersonlInfo === undefined) {
            throw new Error('Required parameter listPersonlInfo was null or undefined when calling updatePersonalInfoUsingPUT.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
          

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Array<CustomerInfoDto>>(`${this.basePath}/applicant/info`,
            listPersonlInfo,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
